import { DashboardLateralNav } from 'components/DashboardLateralNav';
import { Navbar } from 'components/Navbar';
import { useDisclose } from 'hooks/utilHooks';
import { FC } from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

import CreditScoreIcon from '@mui/icons-material/CreditScore';
import { Box, Toolbar } from '@mui/material';

import { TutorMyplanPlanPage } from './TutorMyPlan';
import { TutorContractPlanPage } from './TutorContractPlan';
import { TutorUserPlanProvider } from 'context/TutorUserPlanContext';
import { useTutorUser } from 'hooks/useUser';

const items = [
  {
    name: 'Meu Plano',
    url: '/my-plan',
    component: <CreditScoreIcon />,
    route: '/my-plan',
  },
];

const Component: FC = () => {
  const { isOpen, onToggle } = useDisclose(true);
  const { path } = useRouteMatch();

  const { hasPlanSubscription, user } = useTutorUser();

  return (
    <Box sx={{ display: 'flex' }}>
      <DashboardLateralNav
        openSideMenu={isOpen}
        toggleDrawer={onToggle}
        items={items}
        setPageTitle={() => {}}
      />

      <Navbar
        openSideMenu={isOpen}
        toggleDrawer={onToggle}
        pageTitle={hasPlanSubscription ? 'Meu Plano' : 'Pagamento'}
      />

      {user?.id ? (
        <Box
          component="main"
          sx={{
            backgroundColor: '#efefef',
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto',
          }}
        >
          <Toolbar />

          <Switch>
            <Route exact path={`${path}/my-plan`}>
              {hasPlanSubscription ? (
                <TutorMyplanPlanPage />
              ) : (
                <Redirect path="/tutor/dashboard" to="/tutor/contract-plan" />
              )}
            </Route>

            <Route exact path={`${path}/contract-plan`}>
              {!hasPlanSubscription ? (
                <TutorContractPlanPage />
              ) : (
                <Redirect path="/tutor/dashboard" to="/tutor/plan-plan" />
              )}
            </Route>

            <Route exact path="/tutor/dashboard">
              {hasPlanSubscription ? (
                <Redirect path="/tutor/dashboard" to="/tutor/my-plan" />
              ) : (
                <Redirect path="/tutor/dashboard" to="/tutor/contract-plan" />
              )}
            </Route>
          </Switch>
        </Box>
      ) : null}
    </Box>
  );
};

export const TutorPages = () => {
  return (
    <TutorUserPlanProvider>
      <Component />
    </TutorUserPlanProvider>
  );
};
